import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { CopyAssistContextState } from '../types';

export const initialCopyAssistContextState: CopyAssistContextState = {
  copyAssistFormState: null,
  activatedFormField: null,
  activateCopyAssist: noop,
  closeCopyAssist: noop,
};

export const CopyAssistContext = createContext(initialCopyAssistContextState);

export const useCopyAssistContext = () => useContext(CopyAssistContext);
